import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui";
import { Input } from "@/components/ui/Input";
import { useMarketplaceRedirect } from "@/hooks/useMarketplace";
import { useToast } from "@/hooks/useToast";
// Validation schema
const marketplaceRedirectSchema = z.object({
    customerIdentifier: z.string().min(1, 'Customer identifier is required').regex(/^[a-zA-Z0-9-_]+$/, 'Customer identifier must contain only alphanumeric characters, hyphens, and underscores'),
    customerAWSAccountID: z.string().min(1, 'AWS Account ID is required').regex(/^\d{12}$/, 'AWS Account ID must be exactly 12 digits'),
    productCode: z.string().min(1, 'Product code is required').regex(/^[a-zA-Z0-9-]+$/, 'Product code must contain only alphanumeric characters and hyphens')
});
export default function MarketplaceRedirectPage() {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
        resolver: zodResolver(marketplaceRedirectSchema),
        defaultValues: {
            customerIdentifier: '',
            customerAWSAccountID: '',
            productCode: ''
        }
    });
    const marketplaceRedirect = useMarketplaceRedirect();
    const toast = useToast();
    const onSubmit = async (data)=>{
        try {
            await marketplaceRedirect.mutateAsync(data);
        // Success - the mutation should handle the redirect
        } catch (error) {
            toast.handleApiError(error, 'Marketplace redirect failed');
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-screen bg-gray-50 py-8 px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-2xl mx-auto",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "bg-white rounded-lg shadow-md p-8",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-2xl font-bold text-gray-900 mb-2",
                        children: "Marketplace Redirect Test"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-gray-600 mb-6",
                        children: "This page tests the marketplace redirect endpoint with mock data."
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ _jsx(Input, {
                                    label: "Customer Identifier",
                                    type: "text",
                                    placeholder: "e.g., cust-abc-123",
                                    ...register('customerIdentifier'),
                                    errors: errors.customerIdentifier
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ _jsx(Input, {
                                    label: "Customer AWS Account ID",
                                    type: "text",
                                    placeholder: "e.g., 123456789012",
                                    ...register('customerAWSAccountID'),
                                    errors: errors.customerAWSAccountID
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ _jsx(Input, {
                                    label: "Product Code",
                                    type: "text",
                                    placeholder: "e.g., prod-xyz-456",
                                    ...register('productCode'),
                                    errors: errors.productCode
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex justify-end pt-4",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    variant: "simple",
                                    color: "navy-90",
                                    disabled: isSubmitting || marketplaceRedirect.isPending,
                                    className: "min-w-[120px]",
                                    children: isSubmitting || marketplaceRedirect.isPending ? 'Redirecting...' : 'Submit'
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
